import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";

const modulePages = import.meta.glob('../../Modules/**/resources/assets/js/Pages/**/*.vue');
const appPages = import.meta.glob('./Pages/**/*.vue');

export function resolveVuePage(name) {
    const parts = name.split('::');

    if (parts.length > 1) {
        const [moduleName, pageName] = parts;
        const possiblePaths = [
            `../../Modules/${moduleName}/resources/assets/js/Pages/${pageName}.vue`,
            `../../Modules/${moduleName}/resources/assets/js/Pages/${pageName}/Index.vue`,
        ];

        return resolvePageComponent(possiblePaths[0], modulePages).catch(() => {
            return resolvePageComponent(possiblePaths[1], modulePages);
        });
    }

    return resolvePageComponent(`./Pages/${name}.vue`, appPages);
}
